import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { mobileNavOpen: Boolean };
  static targets = ["mobileNavEl"];

  initialize() {
    this.mobileNavOpen = false;
  }

  toggleMobileNav() {
    if (!this.mobileNavOpen) {
      this.mobileNavOpen = true;
      document.body.classList.add("overflow-hidden");
      this.mobileNavElTarget.classList.remove("hidden");
    } else {
      this.closeMobileNav();
    }
  }

  closeMobileNav() {
    this.mobileNavOpen = false;
    document.body.classList.remove("overflow-hidden");
    this.mobileNavElTarget.classList.add("hidden");
  }

  toggleJournalView() {
    console.log("toggleJournalView");
    document.getElementById("journal-view").classList.remove("hidden");
    document.getElementById("tasks-view").classList.add("hidden");
    document
      .getElementById("tasks-view-button")
      .classList.remove("bg-plate-1", "text-accent");
    document
      .getElementById("journal-view-button")
      .classList.add("bg-plate-1", "text-accent");
  }

  toggleTasksView() {
    console.log("toggleTasksView");
    document.getElementById("journal-view").classList.add("hidden");
    document.getElementById("tasks-view").classList.remove("hidden");
    document
      .getElementById("journal-view-button")
      .classList.remove("bg-plate-1", "text-accent");
    document
      .getElementById("tasks-view-button")
      .classList.add("bg-plate-1", "text-accent");
  }
}
